import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { PageHeader } from 'components/header/PageHeader'
import { RewardsProduct } from 'types/rewards'
import { formatAPY } from '../utils'
import { RewardsHeaderActions } from './RewardsHeaderActions'

interface RewardsPageHeaderProps {
  rewardsProducts: RewardsProduct[]
  description?: string
  showWithdrawButton?: boolean
  showDepositButton?: boolean
}

export const RewardsPageHeader = ({
  rewardsProducts,
  description,
  showWithdrawButton = true,
  showDepositButton = true,
}: RewardsPageHeaderProps) => {
  const { t } = useTranslation()

  const rewardsProductCurrencies =
    rewardsProducts
      .map(product => {
        if (!product?.currency) return null

        return `${product?.currency} (${formatAPY(product?.earningRate)})`
      })
      ?.filter(Boolean) ?? []

  return (
    <PageHeader
      description={
        <Box className="text-foreground-subdued text-body-regular">
          {description || t('rewards.description', { currencies: rewardsProductCurrencies })}{' '}
          <ExternalLink href={process.env.REWARDS_HOW_IT_WORKS_URL} target="_blank">
            {t('rewards.descriptionLink')}
          </ExternalLink>
        </Box>
      }
      renderRightSection={
        <RewardsHeaderActions
          showWithdrawButton={showWithdrawButton}
          showDepositButton={showDepositButton}
        />
      }
    />
  )
}
